import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'suka-navigation',
  template: `
    <nav role="navigation__container">
      <ul class="navigation__items">
        <ng-content></ng-content>
      </ul>
    </nav>
  `,
  encapsulation: ViewEncapsulation.None
})
export class Navigation {
  @HostBinding('attr.role') role = 'complementary';
  @HostBinding('class.navigation') hostClass = true;
}
